/**
 * The value after it stopped changing for `ms` (search-as-you-type without a request per key).
 * Call while a component initializes; read `.value`.
 */
export function debounced<T>(get: () => T, ms = 250): { readonly value: T } {
  let value = $state(get());
  $effect(() => {
    const next = get();
    const timer = setTimeout(() => (value = next), ms);
    return () => clearTimeout(timer);
  });
  return {
    get value() {
      return value;
    },
  };
}
